import {
  BULK_REQUEST_REQUEST_TASKS_TASKS__FETCH_FAILURE,
  BULK_REQUEST_REQUEST_TASKS_TASKS__FETCH_REQUEST,
  BULK_REQUEST_REQUEST_TASKS_TASKS__FETCH_SUCCESS,
  BULK_REQUEST_REQUEST_TASKS_TASKS__PUT_FAILURE,
  BULK_REQUEST_REQUEST_TASKS_TASKS__PUT_REQUEST,
  BULK_REQUEST_REQUEST_TASKS_TASKS__PUT_SUCCESS,
  BULK_REQUEST_REQUEST_TASKS_TASKS__RELOAD_FAILURE,
  BULK_REQUEST_REQUEST_TASKS_TASKS__RELOAD_REQUEST,
  BULK_REQUEST_REQUEST_TASKS_TASKS__RELOAD_SUCCESS,
} from '@app/store/actionTypes';
import FormValue from '@app/store/transport-layer/bulk-request/bulk-requests/request-tasks/FormValue';
import RequestTasksResponse from '@app/store/transport-layer/bulk-request/bulk-requests/request-tasks/RequestTasksResponse';

export function fetchRequestTasks(payload: { bulkRequestId: string; page: number; count: number }) {
  return {
    type: BULK_REQUEST_REQUEST_TASKS_TASKS__FETCH_REQUEST,
    payload,
  };
}

export function fetchRequestTasksSuccess(payload: RequestTasksResponse) {
  return {
    type: BULK_REQUEST_REQUEST_TASKS_TASKS__FETCH_SUCCESS,
    payload,
  };
}

export function fetchRequestTasksFailure(payload: Error) {
  return {
    type: BULK_REQUEST_REQUEST_TASKS_TASKS__FETCH_FAILURE,
    payload,
    error: true,
  };
}

export function putRequestTasks(payload: { bulkRequestId: string; formValues: FormValue[] }) {
  return {
    type: BULK_REQUEST_REQUEST_TASKS_TASKS__PUT_REQUEST,
    payload,
  };
}

export function putRequestTasksSuccess(payload: string) {
  return {
    type: BULK_REQUEST_REQUEST_TASKS_TASKS__PUT_SUCCESS,
    payload,
  };
}

export function putRequestTasksFailure(payload: Error) {
  return {
    type: BULK_REQUEST_REQUEST_TASKS_TASKS__PUT_FAILURE,
    payload,
    error: true,
  };
}

export function reloadRequestTasks(payload: string) {
  return {
    type: BULK_REQUEST_REQUEST_TASKS_TASKS__RELOAD_REQUEST,
    payload,
  };
}

export function reloadRequestTasksSuccess(payload: RequestTasksResponse) {
  return {
    type: BULK_REQUEST_REQUEST_TASKS_TASKS__RELOAD_SUCCESS,
    payload,
  };
}

export function reloadRequestTasksFailure(payload: Error) {
  return {
    type: BULK_REQUEST_REQUEST_TASKS_TASKS__RELOAD_FAILURE,
    payload,
    error: true,
  };
}

export type TasksAction =
  | ReturnType<typeof fetchRequestTasks>
  | ReturnType<typeof fetchRequestTasksSuccess>
  | ReturnType<typeof fetchRequestTasksFailure>
  | ReturnType<typeof putRequestTasks>
  | ReturnType<typeof putRequestTasksSuccess>
  | ReturnType<typeof putRequestTasksFailure>
  | ReturnType<typeof reloadRequestTasks>
  | ReturnType<typeof reloadRequestTasksSuccess>
  | ReturnType<typeof reloadRequestTasksFailure>;
